import release from "./release.json";
import { validateReleaseVersion } from "./lib/release-version";

export default defineAppConfig({
  version: validateReleaseVersion(release),
});
